import type { FallbackUrl } from '../../types';
import { getFallbackUrl } from '../get-fallback-url';

/**
 * Utility function to extract the URL string from a `FallbackUrl` parameter that may be undefined.
 * Handles both string and function types, as well as undefined values.
 *
 * @param fallbackUrl - Either a string URL, a function that returns a string URL, or undefined
 * @returns The URL as a string, or undefined if the input was undefined
 */
export const getFallbackUrlMaybe = (fallbackUrl: FallbackUrl | undefined): string | undefined => {
	if (fallbackUrl === undefined) {
		return undefined;
	}

	return getFallbackUrl(fallbackUrl);
};
